<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn 
          v-bind="attrs" 
          v-on="on" 
          x-medium  
          large block        
          rounded 
          color="primary"
          dark>
            Agregar Producto
      </v-btn>
    </template>
    <v-card>
      <v-toolbar 
        dark 
        color="secondary">
            <v-btn 
              icon  
              dark 
              class="btn btn-primary"
              @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
        <v-toolbar-title>Agregar Producto</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template> 

      </v-toolbar>   

      <v-tabs-items v-model="tab" class="container mt-5">
              
        <v-tab-item>
          <div class="container mt-4">
            <addProducts/>
          </div>
        </v-tab-item>

      </v-tabs-items>     
      
    </v-card>
  </v-dialog>
</template>

<script>
import  EventBus  from '@/utils/event_bus.js'; 
import addProducts from "@/views/products/pages/add_products/components/form_add_products_component.vue"

export default {

  name: "addProductPage",
  components: {
    addProducts
  },
  data() {
    return {
      dialog: false,
      tab: null,
      items: [
        "Datos Completos"
      ]
    };
  },

  mounted() {
    EventBus.$on('form-submit-products', () => {
      // Cierra el v-dialog
      this.dialog = false
      
    });
  },
  
  methods: {
    
  },
  computed: {
    
  },
};
</script>
  